import Immutable from 'immutable';

const initialState = Immutable.fromJS(window && window.SESSION ? window.SESSION : {});

export const LOGIN_SUBMIT = 'takeback/session/LOGIN_SUBMIT';
export const LOGIN_SUCCESS = 'takeback/session/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'takeback/session/LOGIN_FAILURE';

export const LOGOUT_SUBMIT = 'takeback/session/LOGOUT_SUBMIT';
export const LOGOUT_SUCCESS = 'takeback/session/LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'takeback/session/LOGOUT_FAILURE';

export const REGISTER_SUBMIT = 'takeback/session/REGISTER_SUBMIT';
export const REGISTER_SUCCESS = 'takeback/session/REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'takeback/session/REGISTER_FAILURE';

export const TENANT_ACTIVATE = 'takeback/session/TENANT_ACTIVATE';
export const TENANT_ACTIVATE_SUCCESS = 'takeback/session/TENANT_ACTIVATE_SUCCESS';
export const TENANT_ACTIVATE_ERROR = 'takeback/session/TENANT_ACTIVATE_ERROR';

export const SESSION_INVALIDATE = 'takeback/session/SESSION_INVALIDATE';
export const SESSION_MAINTENANCE = 'takeback/session/SESSION_MAINTENANCE';

/* Reducers */
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case LOGIN_SUCCESS: {
        return state.merge(action.payload);
    }
    case LOGOUT_SUCCESS: {
        localStorage.clear();
        sessionStorage.clear();
        return state.merge(action.payload);
    }
    case REGISTER_SUCCESS: {
        return state.merge(action.payload);
    }
    case TENANT_ACTIVATE_SUCCESS: {
        return state.merge(action.payload);
    }
    case SESSION_INVALIDATE: return state.merge({
        admin: false,
        authenticated: false,
        user: null,
    });
    case SESSION_MAINTENANCE: return state.set('maintenance', action.payload);
    default: return state;
    }
}

export function activateTenant() {
    return { type: TENANT_ACTIVATE };
}

export function setMaintenance(isMaintenance) {
    return { type: SESSION_MAINTENANCE, payload: isMaintenance };
}

/* Selectors */
export function isAuthenticated(state) {
    return !!(state.session || state).get('authenticated');
}

/* Actions */
export function logout(params = {}, options = {}) {
    return Object.assign({ type: LOGOUT_SUBMIT, params }, options);
}
